import { render, staticRenderFns } from "./researchCenter.vue?vue&type=template&id=7aa68ab3&scoped=true"
import script from "./researchCenter.vue?vue&type=script&lang=js"
export * from "./researchCenter.vue?vue&type=script&lang=js"
import style0 from "./researchCenter.vue?vue&type=style&index=0&id=7aa68ab3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa68ab3",
  null
  
)

export default component.exports